import { useEffect, useState } from "react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  ["Residences", "#residences"],
  ["Manifesto", "#manifesto"],
  ["Amenities", "#amenities"],
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled
          ? "bg-[#f7f2e7]/85 backdrop-blur-md border-b border-[#16301f]/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToId("#top")}
          className="flex items-center gap-3 group"
        >
          <img src="/images/logo.png" alt="Parker Furnished Stays logo" className="w-10 h-10 sm:w-11 sm:h-11 rounded-full" />
          <span className="font-display tracking-[0.18em] text-sm sm:text-base uppercase text-[#16301f]">
            Parker Furnished Stays
          </span>
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map(([label, href]) => (
            <button
              key={href}
              data-testid={`nav-link-${label.toLowerCase()}`}
              onClick={() => scrollToId(href)}
              className="text-xs uppercase tracking-[0.22em] text-[#16301f]/60 hover:text-[#16301f] transition-colors duration-300"
            >
              {label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-inquiry-btn"
          onClick={() => scrollToId("#inquiry")}
          className="bg-[#16301f] text-[#f7f2e7] text-xs uppercase tracking-[0.22em] px-5 py-2.5 hover:bg-[#284b35] transition-colors duration-300"
        >
          Enquire
        </button>
      </div>
    </header>
  );
}
